import {
    Message
} from 'element-ui';

/**
 * 运输单状态:TRANSPORT_STATUS
 * 订单类型:ORDER_TYPE
 * 任务类型:TASK_TYPE
 * 来源系统:SOURCE_SYSTEM
 * 网调渠道:WDQD
 * 运输方式:SYS_TMS_TRANSPORT_TYPE
 * 计费业务类型:BUSINESS_TYPE
 * 订单来源:ORDER_SOURCE
 * 项目分类:PROJECT_CLASSIFY
 * 业务大类:SYS_ORDER_BUSINESS_TYPE
 * 专业公司:SYS_PROFESSIONAL_COMPANY
 * 运输产品:OMS_TRANSPORT_PRODUCT
 */

const optionNum = 'DELIVERY_TYPE,TRANSPORT_STATUS,OTP_TMS_PROCUREMENT_CHANNEL,ORDER_TYPE,ROJECT_CLASSIFY,TASK_TYPE,SOURCE_SYSTEM,WMS_STATUS,WDQD,TMS_SHIPPING_TYPE,SYS_TMS_TRANSPORT_TYPE,BUSINESS_TYPE,ORDER_SOURCE,PROJECT_CLASSIFY,SYS_ORDER_BUSINESS_TYPE,SYS_PROFESSIONAL_COMPANY,OMS_TRANSPORT_PRODUCT,OMS_PARAMS_ENTITY_ID,APPOINTMENT_TYPE,ORDER_SERVICE_TYPE';

/**
 * @description 上表格数据格式化
 * @param {Array} data 上表格数据
 * @param {Object} dictData 数据字典
 * @returns []
 */
const initTableData = (data, dictData) => {
    data.forEach(item => {
        item.procurementChannelName = t(item.procurementChannel, dictData, 'OTP_TMS_PROCUREMENT_CHANNEL');
        item.taskStatusName = t(item.taskStatus, dictData, 'TRANSPORT_STATUS');
        item.orderTypeName = t(item.orderType, dictData, 'ORDER_TYPE');
        item.deliveryTypeName = t(item.deliveryType, dictData, 'DELIVERY_TYPE');
        item.projectClassifyName = t(item.projectClassify, dictData, 'PROJECT_CLASSIFY');
        item.taskTypeName = t(item.taskType, dictData, 'TASK_TYPE');
        item.sourceSystemName = t(item.sourceSystem, dictData, 'SOURCE_SYSTEM');
        item.shippingTypeName = t(item.shippingType, dictData, 'TMS_SHIPPING_TYPE');
        item.wmsStatusName = t(item.wmsStatus, dictData, 'WMS_STATUS');
        item.serviceTypeName = t(item.serviceType, dictData, 'ORDER_SERVICE_TYPE');
        item.snAppointmentTypeName = t(item.snAppointmentType, dictData, 'APPOINTMENT_TYPE');
        item.wdqdName = t(item.wdqd, dictData, 'WDQD');
        // 业务大类
        item.businessCategoryName = t(item.businessCategory, dictData, 'SYS_ORDER_BUSINESS_TYPE');
        // 运输方式
        item.transportTypeName = t(item.transportType, dictData, 'SYS_TMS_TRANSPORT_TYPE');
        // 业务类型
        item.businessTypeName = t(item.businessType, dictData, 'BUSINESS_TYPE');
        // 事业部
        item.entityIdName = t(item.entityId + '', dictData, 'OMS_PARAMS_ENTITY_ID');
        // 订单来源
        item.orderSourceName = t(item.orderSource, dictData, 'ORDER_SOURCE');
        // 专业公司
        item.professionalCompanyName = t(item.professionalCompany, dictData, 'SYS_PROFESSIONAL_COMPANY');
        // 运输产品
        item.transportProductName = t(item.transportProduct, dictData, 'OMS_TRANSPORT_PRODUCT');
        item.supplierReserveFlagName = item.supplierReserveFlag === 'Y' ? '是' : '否';
        item.distributionFlagName = item.distributionFlag === 'Y' ? '是' : '否';
        item.distributionContinueFlagName = item.distributionContinueFlag === 'Y' ? '是' : '否';
        item.carrierVisibleFlagName = item.carrierVisibleFlag === 'Y' ? '是' : '否';
        item.collectionFlagName = item.collectionFlag === 'Y' ? '是' : '否';
        item.isJzpName = item.isJzp === 'Y' ? '是' : '否';
        item.deliverypayTypeName = +item.deliverypayType === 2 ? '到付' : '寄付';
        item.scPosFlagName = +item.scPosFlag === 0 ? '否' : (+item.scPosFlag === 1 ? '是' : item.scPosFlag);
        item.cnDispatchName = +item.cnDispatch === 0 ? '否' : (+item.cnDispatch === 1 ? '是' : item.cnDispatch);
        item.intelligentStatusName = +item.intelligentStatus === 0 ? '未智能调度' : (+item.intelligentStatus === 1 ? '智能调度成功' : '智能调度失败');
        item.planOrderFlagName = +item.planOrderFlag === 1 ? '是' : '否';
        item.logisticModeName = item.logisticMode === 'WT' ? '是' : '否';
        // 是否提供装卸服务
        item.handlingStatuseName = +item.handlingStatus === 1 ? '是' : '否';
        // 是否已分仓
        item.isAllocateWhName = +item.isAllocateWh === 1 ? '是' : '否';
        // 京东VC单号 defineStr1，要 sourceSystem == "OFC_JINGDONG"，才显示
        /* TODO:调度的判断 */
        // item.defineStr1 = item.sourceSystem === 'OFC_JINGDONG' ? item.defineStr1 : '';
        /* TODO:大物流的判断 */
        item.defineStr1 = item.kaType === 'OFC_JINGDONG' ? item.defineStr1 : '';

        // 实发数量
        item.totalRealReceiveCount = 0;

        if (item.sourceSystem === 'CAINIAO' && item.orderType === 'YS' && +item.serviceType === 8) {
            item.orderTypeName = '逆向运输';
        }
        item.appointTimeFlag = item.appointmentTime ? '是' : '否';
        if (item.transportDetails && item.transportDetails.length > 0) {
            const splitArr = item.transportDetails[0].itemClassName ? item.transportDetails[0].itemClassName.split('.') : [];
            splitArr.shift();
            item.itemClassName = splitArr.join('.');
            item.transportDetails.forEach(e => {
                // 实发数量
                item.totalRealReceiveCount += e.actQty;
            })
        }
        item.arriveAppointmentRequireFlagName = +item.arriveAppointmentRequireFlag === 2 ? '是' : '否';
    });
    return data;
};

const t = (key, dict, dicType) => {
    if (typeof (key) === 'undefined' || key === '') return '';
    if (!dict[dicType]) {
        Message.warning(`未获取数据字典: ${dicType}`);
        return key;
    };
    return dict[dicType][key];
};

export function searchFieldSeperated (value) {
    return (value || '')
        .replace('，', ',')
        .replace(/\s+/g, ',')
        .split(/[,，]/)
        .map(no => no.trim())
        .filter(no => no);
}

export {
    initTableData,
    optionNum
};
